export default __webpack_public_path__ + "static/media/8dbf76679683884e78aadd08dc473493.jpg";